import { http } from '@/core/helpers/axiosHelper';
import type { ApiResource } from '@future-harry/nxt-styles';
import type { JobBoardResponse, JobBoard } from '@/core/collections/job-boards/job-board.interface';
import { buildJobBoardRequestConfig, mapJobBoard, serializeJobBoard } from '@/core/collections/job-boards/job-board.helper';
import { JOB_BOARD_ENDPOINTS } from '@/core/collections/job-boards/job-board.endpoints';

export async function fetchJobBoard(id?: string): Promise<JobBoard> {
   const { url, params } = buildJobBoardRequestConfig(id);

   const response = await http.get<ApiResource<JobBoardResponse>>(url, { params });

   return mapJobBoard(response.data.data);
}

export async function fetchJobBoards(page: number = 1, perPage: number = 15): Promise<ApiResource<Array<JobBoard>>> {
   const response = await http.get<ApiResource<Array<JobBoard>>>(JOB_BOARD_ENDPOINTS.GET_ALL(), {
      params: {
         per_page: perPage,
         page: page,
         include: 'tenant',
      },
   });

   return response.data;
}

export async function createJobBoard(jobBoard: JobBoard, tenantId: number): Promise<JobBoardResponse> {
   const payload = serializeJobBoard(jobBoard);

   const response = await http.post<ApiResource<JobBoardResponse>>(JOB_BOARD_ENDPOINTS.POST(), {
      ...payload,
      tenant_id: tenantId,
   });

   return response.data.data;
}

export async function updateJobBoard(id: string | undefined, jobBoard: JobBoard): Promise<JobBoard> {
   const { url, params } = buildJobBoardRequestConfig(id);
   const payload = serializeJobBoard(jobBoard);

   const response = await http.put<ApiResource<JobBoardResponse>>(url, payload, { params });

   return mapJobBoard(response.data.data);
}
